// extracted by mini-css-extract-plugin
export default {"page":"nZ","heading":"oZ","subheading":"pZ","flavorbox":"qZ","inner":"rZ","image":"sZ","label":"tZ","flavorselect":"uZ","arrow":"vZ","flavorswrap":"wZ","flavorsheader":"xZ","flavorsnav":"yZ","flavorsinner":"zZ","cancelbtn":"AZ","flavorsbottom":"BZ","retakebtn":"CZ","continueBtn":"EZ","drawerinner":"FZ","videowrap":"GZ","flavorsbottomnav":"HZ"};
    if(module.hot) {
      // 1738836198225
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  